const DATA_SAVED = "extragestor/preinscripciones/DATA_SAVED";
const RESET_DATA_SAVED = "extragestor/preinscripciones/RESET_DATA_SAVED";

const PREINSCRIPCIONES_POR_COLEGIO =
  "extragestor/preinscripciones/PREINSCRIPCIONES_POR_COLEGIO";
const RESET_PREINSCRIPCIONES_POR_COLEGIO =
  "extragestor/preinscripciones/RESET_PREINSCRIPCIONES_POR_COLEGIO";

const ADDED_PREINSCRIPCIONES_DEL_COLEGIO =
  "extragestor/preinscripciones/ADDED_PREINSCRIPCIONES_DEL_COLEGIO";
const CHANGED_PREINSCRIPCIONES_DEL_COLEGIO =
  "extragestor/preinscripciones/CHANGED_PREINSCRIPCIONES_DEL_COLEGIO";
const REMOVED_PREINSCRIPCIONES_DEL_COLEGIO =
  "extragestor/preinscripciones/REMOVED_PREINSCRIPCIONES_DEL_COLEGIO";
const RESET_PREINSCRIPCIONES_DEL_COLEGIO =
  "extragestor/preinscripciones/RESET_PREINSCRIPCIONES_DEL_COLEGIO";

const OBTENER_DATOS_COLEGIO =
  "extragestor/preinscripciones/OBTENER_DATOS_COLEGIO";
const LIMPIAR_DATOS_COLEGIO =
  "extragestor/preinscripciones/LIMPIAR_DATOS_COLEGIO";

const OBTENER_DATOS_PREINSCRIPCION =
  "extragestor/preinscripciones/OBTENER_DATOS_PREINSCRIPCION";
const LIMPIAR_DATOS_PREINSCRIPCION =
  "extragestor/preinscripciones/LIMPIAR_DATOS_PREINSCRIPCION";

const COLUMNA_SELECCIONADA =
  "extragestor/preinscripciones/COLUMNA_SELECCIONADA";
const RESET_COLUMNA_SELECCIONADA =
  "extragestor/preinscripciones/RESET_COLUMNA_SELECCIONADA";

/*---*/
export {
  DATA_SAVED,
  RESET_DATA_SAVED,
  PREINSCRIPCIONES_POR_COLEGIO,
  RESET_PREINSCRIPCIONES_POR_COLEGIO,
  // PREINSCRIPCIONES_DEL_COLEGIO,
  ADDED_PREINSCRIPCIONES_DEL_COLEGIO,
  CHANGED_PREINSCRIPCIONES_DEL_COLEGIO,
  REMOVED_PREINSCRIPCIONES_DEL_COLEGIO,
  RESET_PREINSCRIPCIONES_DEL_COLEGIO,
  OBTENER_DATOS_COLEGIO,
  LIMPIAR_DATOS_COLEGIO,
  OBTENER_DATOS_PREINSCRIPCION,
  LIMPIAR_DATOS_PREINSCRIPCION,
  COLUMNA_SELECCIONADA,
  RESET_COLUMNA_SELECCIONADA
};



// WEBPACK FOOTER //
// ./src/ducks/preinscripciones/types.js